import Vue from 'vue';
import axios from 'axios';
import SingleSlider from '../Components/SingleSlider';

var v = new Vue({
    el: '#vaihtoauton-leasinglaskuri',
    data: function () {
        return {
            tunniste: (<any>window).autontunniste,
            ytunnus: (<any>window).ytunnus,
            yritysid: (<any>window).yritysid,
            palveluid: (<any>window).palveluid,
            kilometritVaihtoehdot: (<any>window).kilometrit,
            sopimusajat: (<any>window).sopimusajat,
            kuukausierakombinaatiot: (<any>window).kuukausierakombinaatiot,
            valittuKm: (<any>window).kilometrit[0],
            sopimusaika: (<any>window).sopimusajat[0],
            autonhinta: (<any>window).autonhinta,
            leasingVuokra: 0,
            viimeisinValittuAika: 0,
            vainYksiKilometriVaihtoehto: Boolean,
            UrlJsonData: '',
            oletusArvot: [
                {
                    ContractPeriod: 12,
                    AnnualDistance: 15000
                },
                {
                    ContractPeriod: 24,
                    AnnualDistance: 15000
                },
                {
                    ContractPeriod: 36,
                    AnnualDistance: 15000
                }
            ]
        }
    },

    created: function () {
        this.haeOletusArvot();
        this.laskeLeasingVuokra();
    },
    updated: function () {
    },
    computed: function () {
    },
    mounted: function () {
    },
    methods: {
        laskeLeasingVuokra() {
            this.HaeLeasingRahoitusArvot();
            var valittusopimusaika = this.kuukausierakombinaatiot.filter(obj => {
                return obj.ContractPeriod === this.sopimusaika;
            });

            valittusopimusaika.sort((a, b) => (a.AnnualDistance > b.AnnualDistance) ? 1 : ((b.AnnualDistance > a.AnnualDistance) ? -1 : 0));

            var result = valittusopimusaika.filter(obj => {
                return obj.AnnualDistance === this.valittuKm;
            });

            this.kilometritVaihtoehdot = [];

            valittusopimusaika.forEach(elem => {
                this.kilometritVaihtoehdot.push(elem.AnnualDistance);
            });

            if (this.kilometritVaihtoehdot.length <= 1) {
                this.valittuKm = valittusopimusaika[0].AnnualDistance;
                this.leasingVuokra = valittusopimusaika[0].LeaseAmount;
                this.vainYksiKilometriVaihtoehto = true;
                return;
            }

            this.vainYksiKilometriVaihtoehto = false;

            if (result.length == 0) {
                let lahinArvo = valittusopimusaika.reverse().find(e => e.AnnualDistance <= this.valittuKm);
                if (lahinArvo == null) {
                    this.haeOletusArvot();
                    return;
                }
                this.valittuKm = lahinArvo.AnnualDistance
                this.leasingVuokra = lahinArvo.LeaseAmount
            }

            else {
                this.leasingVuokra = result[0].LeaseAmount;
            }
        },
        haeOletusArvot() {
            const self = this;
            for (var i = 0; i < self.oletusArvot.length; i++) {
                const oletus = self.oletusArvot.flatMap(o =>
                    self.kuukausierakombinaatiot.filter(k =>
                        k.ContractPeriod === o.ContractPeriod &&
                        k.AnnualDistance === o.AnnualDistance
                    )
                );
                if (oletus[1] != null && oletus[1].ContractPeriod != 0 && oletus[1].AnnualDistance != 0) {
                    self.sopimusaika = oletus[1].ContractPeriod;
                    self.valittuKm = oletus[1].AnnualDistance
                    break;
                }
                if (oletus[2] != null && oletus[2].ContractPeriod != 0 && oletus[2].AnnualDistance != 0) {
                    self.sopimusaika = oletus[2].ContractPeriod;
                    self.valittuKm = oletus[2].AnnualDistance
                    break;
                }
                if (oletus[0] != null && oletus[0].ContractPeriod != 0 && oletus[0].AnnualDistance != 0) {
                    self.sopimusaika = oletus[0].ContractPeriod;
                    self.valittuKm = oletus[0].AnnualDistance
                    break;
                }
            }            
        },
        HaeLeasingRahoitusArvot() {
            this.fetchingInprogress = true;
            let hinta: any = this.autonhinta;
            const payload = {
                "tunniste": this.tunniste,
                "caller_url": location.href,
                "ytunnus": this.ytunnus,
                "yritysid": this.yritysid,
                "palveluid": this.palveluid,
                "hinta": Math.round(hinta),
                "sopimusaika": this.sopimusaika,
                "ajokilometrit": this.valittuKm
            };

            this.csrfToken = document.querySelector<HTMLInputElement>("input[name = '__RequestVerificationToken']").value;
            axios.post(`/JulkisetResurssit/HaeLeasingRahoitusArvot`, payload, {
                headers: {
                    'content-type': 'application/json',
                    '__RequestVerificationToken': this.csrfToken
                }
            })
            .then(response => {
                const d = response && response.data;
                const data = (typeof d === 'string') ? JSON.parse(d) : d;
                this.UrlJsonData = data.Data;
            })
            .catch(e => {
                this.fetchingInprogress = false;
                console.error('error', e);
            });
        },
        siirrylaskimeen() {
            const data = JSON.parse(this.UrlJsonData);
            console.log("Siirrytään: " + data.Url);
            window.location.href = data.Url;
        }
    },
    template: `<div class="webX-kontti">
                  <div class="rahoituslaskin_v2_wrapper">
                    <div class="rahoituslaskin_v2_column">
                        <div class="desktop-t-yleinenSisennys rahoituslaskin__mobiili-erotin" style="border-top: none;">
                            <div class="webX-sarake-deskari-20 webX-sarake-tablet-20 webX-sarake-100 webX-sijoita-leveyssuunnassa--keskelle">
                                <br> 
                                <div class="webX-sarake-deskari-100 webX-sarake-tablet-100 webX-sarake-50 webX-sijoita-leveyssuunnassa--keskelle">
                                    <div style="min-height: 56px; position: relative;">
                                        <div style="position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); max-width: 100%">
                                            <img src="/Content/Kuvat/Lahitapiola_logo.png" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="webX-sarake-deskari-30 webX-sarake-tablet-30 webX-sarake-100">    
                            <p style="margin-left:10%; margin-top:10px; font-size: 16px;"><span class="webX-deskari-display--inline webX-tablet-display--inline">Sopimusaika:</span> <strong>{{sopimusaika}} kk</strong></p>
                                <section class="laskuri-section webX-tablet" style="margin-left:10%;">      
                                   <SingleSlider                       
                                       :rangeValues="sopimusajat" 
                                       :tunniste="'sopimusaikaslider'"
                                       :dontResetIfZero="true"
                                       v-model="sopimusaika"
                                       style="width: 90%;"
                                       class="rahoitusslider"
                                        @slider-changed="laskeLeasingVuokra()"
                                   />                    
                               </section>
                            </div>
                            <div class="webX-sarake-deskari-30 webX-sarake-tablet-30 webX-sarake-100">
                                <p style="margin-left:10%; margin-top:10px; font-size: 16px;"><span class="webX-deskari-display--inline webX-tablet-display--inline">Ajokilometrit:</span> <strong>{{valittuKm}} km/v</strong></p>
                                <section class="laskuri-section webX-tablet" style="margin-left:10%;">   
                                    <SingleSlider                       
                                            :rangeValues="kilometritVaihtoehdot" 
                                            :tunniste="'leasingKmSlider'"
                                            :dontResetIfZero="true"
                                            :disabled="vainYksiKilometriVaihtoehto"
                                            v-model="valittuKm"
                                            style="width: 90%;"
                                            class="rahoitusslider"
                                            @slider-changed="laskeLeasingVuokra()"
                                        />
                                </section>
                            </div>
                            <div class="webX-sarake-deskari-20 webX-sarake-tablet-20 webX-sarake-100 webX-sijoita-leveyssuunnassa--keskelle">
                                <p>
                                    <span style="font-size: 80%">Leasingvuokra: </span>
                                    <br/>
                                    <strong>{{leasingVuokra.toFixed(2)}} € / kk</strong>
                                </p>
                                <button type="button" class="istrackable" data-analytics-link="Hae ennakkopäätös" v-on:click="siirrylaskimeen()">Laske rahoitustarjous</button>
                                <input type="hidden" id="hiddenLeasingSopimusaika" :value="sopimusaika"/>
                                <input type="hidden" id="hiddenLeasingAjokilometrit" :value="valittuKm"/>
                                <input type="hidden" id="hiddenLeasingVuokra" :value="leasingVuokra"/>
                                <input type="hidden" id="hiddenLeasingAutonHinta" :value="autonhinta"/>
                            </div>
                            <div class="rahoituslaskin__avaa-lainaehdot webX-display--block" style="margin-top:15px">
                                <div class="rahoituslaskin__laskin-lainaehdot">
                                    <p><br/><small>
                                        Rahoitustarjous on alustava päätös eikä sido sinua mihinkään. Käsitellyistä rahoitushakemuksista lähetetään myyjäliikkeelle ainoastaan yhteystiedot liikkeen yhteydenottoa varten. Lopulliset leasingvuokrauksen ehdot on aina sovittava myyjäliikkeessä, joka myös tekee lopullisen leasinghakemuksen sopimillanne ehdoilla. Voit myös välittää yhteydenottopyynnön ilman laskentaa painamalla nappia "Yhteydenottopyyntö" ja täyttämällä omat yhteystietosi lomakkeelle. Rahoitustarjouksen yhteydessä tehdään luottotietojen tarkistus. Voit lukea tietojenkäsittelystä täältä <a href="https://core-public.editaprima.fi/lahitapiola/download/6590/10" target="_blank">LähiTapiola Rahoitus Oy:n tietosuojaseloste (pdf)</a>. Luottotyyppi: leasingrahoitus.
                                        </small></p>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>`,

    components: {
        SingleSlider,
    }
});
